import React, { useState, useEffect } from 'react';

import { useFreecodeContext } from 'hooks/useContext';
import { identifiers, layouts } from './FreecodeLayoutConstants';
import { Spinner } from 'components/Spinner/spinner';
import FreecodeLayoutDefault from './FreecodeLayoutDefault';
import FreecodeLayoutWide from './FreecodeLayoutWide';
import FreecodeLayoutSmall from './FreecodeLayoutSmall';
import FreecodeCanvas from 'components/FreecodeContent/FreecodeCanvas/FreecodeCanvas';
import FreecodeConsoleAndScore from 'components/FreecodeContent/FreecodeConsoleAndScore/FreecodeConsoleAndScore';
import FreecodeDescription from 'components/FreecodeContent/FreecodeDescription/FreecodeDescription';
import FreecodeApi from 'components/FreecodeContent/FreecodeApi/FreecodeApi';
import FreecodeEditorSolution from 'components/FreecodeContent/FreecodeCodeEditor/FreecodeEditorSolution';

/**
 * Manage components for freecode editor.
 */
export default function FreecodeEditorComponents({ parentComponents }) {
  const { testImpl, layout } = useFreecodeContext();

  const [componentMap, setComponentMap] = useState();

  useEffect(() => {
    if (!testImpl) return;
    setComponentMap((oldState) => {
      let newComponentMap = { ...(parentComponents || {}), ...(oldState || {}) };

      if (!newComponentMap[identifiers.solution]) newComponentMap[identifiers.solution] = <FreecodeEditorSolution />;
      if (!newComponentMap[identifiers.console]) newComponentMap[identifiers.console] = <FreecodeConsoleAndScore />;
      if (!newComponentMap[identifiers.description]) newComponentMap[identifiers.description] = <FreecodeDescription />;

      if (testImpl.api?.challenge?.length) {
        if (!newComponentMap[identifiers.api]) newComponentMap[identifiers.api] = <FreecodeApi />;
      } else if (newComponentMap[identifiers.api]) {
        delete newComponentMap[identifiers.api];
      }

      if (testImpl.configCanvas?.canvasUsed) {
        if (!newComponentMap[identifiers.canvas]) newComponentMap[identifiers.canvas] = <FreecodeCanvas />;
      } else if (newComponentMap[identifiers.canvas]) delete newComponentMap[identifiers.canvas];

      return newComponentMap;
    });
  }, [testImpl, parentComponents]);

  const result = {
    [layouts.spinner]: <Spinner />,
    [layouts.small]: <FreecodeLayoutSmall componentMap={componentMap} />,
    [layouts.default]: <FreecodeLayoutDefault componentMap={componentMap} />,
    [layouts.wide]: <FreecodeLayoutWide componentMap={componentMap} />,
  };

  return componentMap && result[layout];
}
